const listeners = new Set();
let offline = false;

export const subscribeNetworkStatus = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const setOffline = (value) => {
  if (offline === value) {
    return;
  }
  offline = value;
  listeners.forEach((listener) => {
    try {
      listener(offline);
    } catch (error) {
      console.error('NetworkStatus listener error:', error);
    }
  });
};

export const getOffline = () => offline;


